/**
 * @generated SignedSource<<c905c6ceeb0a850edf5c798bc9350b3a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarSellerInfoAndContactLazy_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarSellerInfoAndContact_item">;
  readonly " $fragmentType": "PdpRespSidebarSellerInfoAndContactLazy_item";
};
export type PdpRespSidebarSellerInfoAndContactLazy_item$key = {
  readonly " $data"?: PdpRespSidebarSellerInfoAndContactLazy_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarSellerInfoAndContactLazy_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarSellerInfoAndContactLazy_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarSellerInfoAndContact_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "2a1b1a349f1bae1b3a1d127a673f3faf";

export default node;
